export default "__VITE_ASSET__D0jQset4__"